import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    alertData: {},
    isClear: false,
};

export const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        setAlertData(state, action) {
            state.alertData = action.payload;
        },
        setIsClear(state, action) {
            state.isClear = action.payload;
        },
    },
});

export const { setAlertData, setIsClear } = notificationSlice.actions;
export default notificationSlice.reducer;
